export default "__VITE_ASSET__0a8a2e0d__"